

const apiUrl = process.env.REACT_APP_API_URL || 'https://hutaoadmin.onrender.com/api';

const GET_RESTAURANT = "restaurants/GET_RESTAURANT";
const GET_ONLINE_STATUS = "restaurants/GET_ONLINE_STATUS";
const GET_HOURS = "restaurants/GET_HOURS";
const GET_RESTAURANT_PLANS = "restaurants/GET_PLAN";

const getRestaurant = (restaurant) => ({
    type: GET_RESTAURANT,
    restaurant
})

export const getOnlineStatus = (status) => ({
    type: GET_ONLINE_STATUS,
    status
})
const getHours = (hours) => ({
    type: GET_HOURS,
    hours
})

const getRestaurantPlan = (payload) => ({
    type: GET_RESTAURANT_PLANS,
    payload
})

export const getRestaurantThunk = (id) => async (dispatch) => {
    const response = await fetch(`${apiUrl}/restaurants/${id}`, {
    })

    if (response.ok) {
        const data = await response.json();
        dispatch(getRestaurant(data))
    }
}

export const getOnlineStatusThunk = (id) => async (dispatch) => {
    const response = await fetch(`${apiUrl}/restaurants/${id}/online-status`, {
    })

    if (response.ok) {
        const data = await response.json();
        dispatch(getOnlineStatus(data))
        return data;
    }

}
export const getHoursThunk = (id) => async (dispatch) => {
    const response = await fetch(`${apiUrl}/restaurants/hours/${id}`, {
    })

    if (response.ok) {
        const data = await response.json();
        dispatch(getHours(data))
        return data;
    }
}

export const getRestaurantPlanThunk = (id) => async (dispatch, getState) => {
    const existingPlan = getState()?.restaurants?.plan;
    if (existingPlan?.restaurant_id && Number(existingPlan.restaurant_id) === Number(id)) {
        return existingPlan;
    }

    const res = await fetch(`${apiUrl}/neworders/restaurant/plan/${id}`)

    if (res.ok) {
        const data = await res.json()
        dispatch(getRestaurantPlan(data))
        return data
    }
}

const initialState = { restaurant: null, onlineStatus: null, hours: null, plan: null }

const restaurantReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_RESTAURANT:
            return { ...state, restaurant: action.restaurant }
        case GET_ONLINE_STATUS:
            return { ...state, onlineStatus: action.status }
        case GET_HOURS:
            return { ...state, hours: action.hours }
        case GET_RESTAURANT_PLANS:
            return { ...state, plan: action.payload }
        default:
            return state;
    }
}

export default restaurantReducer;
